import React from "react";
import client1 from "../assets/home2.jpg";
import client2 from "../assets/home5.jpg";
import client3 from "../assets/home6.jpg";

const testimonials = [
  {
    name: "Ramesh Sharma",
    position: "Homeowner",
    quote: "Luxuriya Waterproofing saved my terrace from leakage completely. Professional and timely service!",
    logo: client1,
  },
  {
    name: "Neha Gupta",
    position: "Interior Designer",
    quote: "Their waterproofing solutions are top-notch. Highly recommended for commercial and residential projects.",
    logo: client2,
  },
  {
    name: "Amit Verma",
    position: "Property Manager",
    quote: "Fast, reliable, and effective. Our building hasn’t had a single leakage issue after their service!",
    logo: client3,
  },
];

const TestimonialsSection: React.FC = () => {
  return (
    <section className="bg-gray-50 py-24">
      <div className="max-w-6xl mx-auto px-6 text-center">
        <h2 className="text-4xl md:text-5xl font-serif font-extrabold mb-6">
          What Our Clients Say
        </h2>
        <p className="text-gray-700 mb-16">
          Hear from our satisfied customers and professionals who trust Luxuriya Waterproofing.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {testimonials.map((t, idx) => (
            <div
              key={idx}
              className="bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-500 flex flex-col items-center"
            >
              <img
                src={t.logo}
                alt={t.name}
                className="w-20 h-20 object-cover rounded-full mb-4 border-2 border-amber-600"
              />
              <p className="text-gray-700 text-lg mb-4 text-center">
                “{t.quote}”
              </p>
              <h3 className="text-amber-600 text-xl font-semibold">
                {t.name}
              </h3>
              <span className="text-gray-500 text-sm">
                {t.position}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
